import { render } from "./StatisticsPage.vue?vue&type=template&id=0bbebdcc"
import script from "./StatisticsPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__